import { FormTypeType } from 'Shared/types/ReviewFormTemplate.type';
import instance from './instance';

export const fetchReview = reviewSlug => instance.get(`/reviews/${reviewSlug}`);

export enum FetchReviewsContext {
  feedback_360 = '360_feedback_for_me',
  performance_review_cycle = 'performance_review_cycle',
  performance_reviews_for_me = 'performance_reviews_for_me',
}

export const fetchReviews = ({
  context = FetchReviewsContext.feedback_360,
  reviewCycleSlug,
}: {
  context?: FetchReviewsContext;
  reviewCycleSlug?: string;
}) => {
  return instance.get('/reviews', { params: { context, reviewCycleSlug } });
};

export type ReviewReminderFormType = FormTypeType.self_peer_review | FormTypeType.manager_peer_review;
export type ReviewReminderDataType = {
  reviewFormType: ReviewReminderFormType;
  reviewSlug: string;
};

export const createReviewReminderNotifications = (data: ReviewReminderDataType[]) => {
  return instance.post(`/reviews/create_review_reminder_notifications`, { reviews: data });
};

export const createReview = data => instance.post('/reviews', data);

export const updateReview = (reviewSlug, data) => instance.put(`/reviews/${reviewSlug}`, data);

export const receiverViewedReview = reviewSlug => instance.put(`/reviews/${reviewSlug}/receiver_viewed`);
